function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__a",
  x1: "138.2%",
  x2: "-13.465%",
  y1: "43.865%",
  y2: "54.743%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__b",
  x1: "86.615%",
  x2: "128.27%",
  y1: "49.973%",
  y2: "49.973%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#C9D2DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__e",
  x1: "0%",
  x2: "10.71%",
  y1: "86.815%",
  y2: "27.705%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E9F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__f",
  x1: "42.442%",
  x2: "42.442%",
  y1: "-9.654%",
  y2: "93.218%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__g",
  x1: "-.005%",
  x2: "154.329%",
  y1: "49.721%",
  y2: "49.721%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.94%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__h",
  x1: "86.615%",
  x2: "128.27%",
  y1: "50.023%",
  y2: "50.023%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__i",
  x1: "-168.9%",
  x2: "156.351%",
  y1: "50.099%",
  y2: "50.099%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E9F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__j",
  x1: "3.616%",
  x2: "106.512%",
  y1: "49.961%",
  y2: "49.961%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__m",
  x1: "86.615%",
  x2: "128.27%",
  y1: "49.973%",
  y2: "49.973%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__n",
  x1: "-168.9%",
  x2: "156.351%",
  y1: "50.126%",
  y2: "50.126%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E9F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__o",
  x1: "3.616%",
  x2: "106.512%",
  y1: "50.04%",
  y2: "50.04%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__r",
  x1: "104.012%",
  x2: "203.488%",
  y1: "72.349%",
  y2: "131.177%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "19%",
  stopColor: "#3D4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#454C5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#525B6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67%",
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "82%",
  stopColor: "#7E8FA7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#9CB1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__s",
  x1: "12.142%",
  x2: "119.27%",
  y1: "29.13%",
  y2: "94.241%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "19%",
  stopColor: "#3D4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#454C5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#525B6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67%",
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "82%",
  stopColor: "#7E8FA7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#9CB1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__t",
  x1: "11.936%",
  x2: "125.592%",
  y1: "37.328%",
  y2: "83.819%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "19%",
  stopColor: "#3D4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#454C5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#525B6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67%",
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "82%",
  stopColor: "#7E8FA7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#9CB1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__u",
  x1: "23.927%",
  x2: "121.368%",
  y1: "39.317%",
  y2: "82.833%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "19%",
  stopColor: "#3D4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#454C5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#525B6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67%",
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "82%",
  stopColor: "#7E8FA7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#9CB1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__v",
  x1: "73.059%",
  x2: "147.295%",
  y1: "4.458%",
  y2: "-177.278%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "19%",
  stopColor: "#3D4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#454C5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#525B6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67%",
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "82%",
  stopColor: "#7E8FA7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#9CB1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__w",
  x1: "73.873%",
  x2: "6.869%",
  y1: "102.422%",
  y2: "-45.996%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "19%",
  stopColor: "#3D4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#454C5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#525B6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67%",
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "82%",
  stopColor: "#7E8FA7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#9CB1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__x",
  x1: "120.115%",
  x2: "7.296%",
  y1: "190.792%",
  y2: "-79.303%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "19%",
  stopColor: "#3D4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#454C5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#525B6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67%",
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "82%",
  stopColor: "#7E8FA7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#9CB1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__y",
  x1: "180.718%",
  x2: "90.229%",
  y1: "179.691%",
  y2: "87.17%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__z",
  x1: "47990.832%",
  x2: "48405.68%",
  y1: "-5034.477%",
  y2: "-5078.46%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__A",
  x1: "66990.459%",
  x2: "67568.792%",
  y1: "-11395.673%",
  y2: "-11494.572%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__B",
  x1: "34538.948%",
  x2: "34836.385%",
  y1: "-4323.616%",
  y2: "-4361.348%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shorten-development_svg__C",
  x1: "20.827%",
  x2: "102.996%",
  y1: "37.78%",
  y2: "76.015%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "19%",
  stopColor: "#3D4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#454C5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#525B6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67%",
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "82%",
  stopColor: "#7E8FA7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#9CB1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "shorten-development_svg__k",
  cx: "50.008%",
  cy: "50.279%",
  r: "50.242%",
  fx: "50.008%",
  fy: "50.279%",
  gradientTransform: "matrix(.99331 0 0 1 .003 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "shorten-development_svg__l",
  cx: "50.322%",
  cy: "50.279%",
  r: "50.242%",
  fx: "50.322%",
  fy: "50.279%",
  gradientTransform: "matrix(.99331 0 0 1 .003 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "shorten-development_svg__p",
  cx: "50.008%",
  cy: "49.722%",
  r: "50.242%",
  fx: "50.008%",
  fy: "49.722%",
  gradientTransform: "matrix(.99331 0 0 1 .003 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "shorten-development_svg__q",
  cx: "50.322%",
  cy: "49.722%",
  r: "50.242%",
  fx: "50.322%",
  fy: "49.722%",
  gradientTransform: "matrix(.99331 0 0 1 .003 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "shorten-development_svg__c",
  width: "117.4%",
  height: "535.7%",
  x: "-8.7%",
  y: "-246.4%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: -4,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.669908217 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "shorten-development_svg__d",
  d: "M82.98 311h344.04c3.973 0 3.973 14 0 14H82.98c-3.973 0-3.973-14 0-14z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__a)",
  d: "M518.972 287.29c41.509-46.59 44.438-111.55 1.694-147.6-52.502-44.28-120.246-68.432-287.915-50.988C24.856 110.33-8.935 235.54 56.559 287.961c25.466 20.381 79.973 17.729 122.843-34.217 43.188-52.33 93.996-67.761 149.039 31.533 33.01 59.546 139.723 59.04 190.531 2.013",
  transform: "rotate(-160 285.676 188)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__b)",
  fillRule: "nonzero",
  d: "M82.98 213h344.04c3.973 0 3.973 14 0 14H82.98c-3.973 0-3.973-14 0-14z",
  opacity: 0.8,
  transform: "matrix(1 0 0 -1 0 403)"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  opacity: 0.8,
  transform: "matrix(1 0 0 -1 0 599)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#shorten-development_svg__c)",
  xlinkHref: "#shorten-development_svg__d"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#shorten-development_svg__b)",
  xlinkHref: "#shorten-development_svg__d"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__e)",
  d: "M175.87.648h134v89.481l-134-.727z",
  transform: "translate(100 1.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#23C386",
  d: "M300.02 73.583v-3.056c0-.555.987-1.388 1.777-1.388l23.61-.14c.395 0 .593.14.593.417v3.056c0 .555-.988 1.389-1.778 1.389l-23.61.139c-.395 0-.692-.14-.593-.417zm40.814-4.07L384.391 69c.406 0 .609.128.609.384v2.82c0 .514-1.015 1.283-1.828 1.283L339.616 74c-.406 0-.61-.129-.61-.385v-2.82c-.101-.641 1.016-1.282 1.828-1.282zM300 61.56v-2.95c0-.537 1.008-1.342 1.815-1.342l34.58-.268c.403 0 .605.134.605.402v2.952c0 .537-1.008 1.342-1.815 1.342l-34.58.268c-.403.134-.605-.134-.605-.403zm50 .012v-2.875c0-.522 1-1.306 4.1-1.437L394 57c-1.8.13-1.6.261-1.6.522v2.875c0 .523-1 1.307-1.8 1.307l-39.9.26c-.4.132-.7-.13-.7-.391zm18-16.135v2.952c0 .536-1.007 1.341-1.813 1.341l-26.582.27c-.403 0-.604-.134-.604-.403v-2.952c0-.536 1.007-1.341 1.813-1.341l26.583-.269c.403-.134.604.135.604.403zm-68 4.111v-3.033c0-.551.989-1.378 1.78-1.378L325.406 45c.395 0 .593.138.593.413v3.033c0 .552-.989 1.38-1.78 1.38l-23.627.137c-.395.138-.593-.138-.593-.414zm0-10.955V35.62c0-.54 1.019-1.351 1.834-1.351l35.555-.27c.407 0 .611.135.611.405v2.973c0 .54-1.019 1.351-1.834 1.351l-35.555.27c-.407 0-.611-.134-.611-.405zm50-1V34.62c0-.54.997-1.351 1.795-1.351l33.607-.27c.399 0 .598.135.598.405v2.973c0 .54-.997 1.351-1.795 1.351l-33.607.27c-.399 0-.598-.134-.598-.405zm-50-11.011v-3.056c0-.555.989-1.388 1.78-1.388l23.627-.14c.395 0 .593.14.593.417v3.056c0 .555-.989 1.389-1.78 1.389l-23.626.14c-.296 0-.593-.14-.593-.417zm39-1.022v-2.95c0-.537 1.005-1.342 1.809-1.342L378.397 21c.402 0 .603.134.603.402v2.952c0 .537-1.005 1.342-1.809 1.342l-37.588.268c-.402.134-.603-.134-.603-.403z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__f)",
  d: "M0 32.633c27.365 0 19.266 35 41.365 35C58.595 67.633 58.595 49 72.781 49c17.386 0 21.283 23.633 46.719 23.633 15.472 0 22.15-11.464 42.164-11.464 20.014 0 40.123 36.464 38.336 36.464H0v-65z",
  transform: "translate(100 1.367)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shorten-development_svg__g)",
  strokeWidth: 3,
  d: "M0 32.633c27.365 0 19.266 35 41.365 35C58.595 67.633 58.595 49 72.781 49c17.386 0 21.283 23.633 46.719 23.633 15.472 0 22.15-11.464 42.164-11.464 20.014 0 40.123 36.464 38.336 36.464",
  transform: "translate(100 1.367)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__h)",
  d: "M8.298.644h359.274c4.15 0 7.52 3.348 7.52 7.598v69.03c0 4.122-3.37 7.6-7.52 7.6H8.298c-4.149 0-7.52-3.35-7.52-7.6V8.115c0-4.122 3.371-7.47 7.52-7.47z",
  opacity: 0.8,
  transform: "translate(63 189.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__i)",
  d: "M8.168.644h309.617c4.149 0 7.39 3.348 7.39 7.34v69.418c0 4.12-3.37 7.34-7.39 7.34H8.168c-4.149 0-7.39-3.348-7.39-7.34V7.985c0-3.993 3.241-7.341 7.39-7.341z",
  transform: "translate(63 189.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#748DAD",
  d: "M129.124 217.571h221.192c3.76 0 6.742 2.962 6.742 6.697v15.068c0 3.735-2.982 6.697-6.742 6.697H129.124c-3.76 0-6.742-2.962-6.742-6.697v-15.068c0-3.735 3.112-6.697 6.742-6.697z",
  opacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__j)",
  d: "M33.748.07H228.23c3.501 0 6.483 2.833 6.483 6.439v15.583c0 3.477-2.852 6.44-6.483 6.44H33.748c-3.501 0-6.483-2.834-6.483-6.44V6.51c0-3.606 2.852-6.44 6.483-6.44z",
  opacity: 0.8,
  transform: "translate(122.345 217.502)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(72.076 221.564)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.594,
  cy: 10.174,
  fill: "url(#shorten-development_svg__k)",
  rx: 9.594,
  ry: 9.53
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.594,
  cy: 10.174,
  fill: "#23C386",
  rx: 5.575,
  ry: 5.538
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(95.414 221.564)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.594,
  cy: 10.174,
  fill: "url(#shorten-development_svg__l)",
  rx: 9.594,
  ry: 9.53
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.594,
  cy: 10.174,
  fill: "#23C386",
  rx: 5.575,
  ry: 5.538
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__m)",
  d: "M8.298.129h359.274c4.15 0 7.52 3.348 7.52 7.598v69.16c0 4.12-3.37 7.598-7.52 7.598H8.298c-4.149 0-7.52-3.349-7.52-7.599V7.727C.778 3.607 4.149.13 8.298.13z",
  opacity: 0.8,
  transform: "translate(63 91.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__n)",
  d: "M8.168.129h309.617c4.149 0 7.39 3.348 7.39 7.34v69.417c0 4.122-3.37 7.341-7.39 7.341H8.168c-4.149 0-7.39-3.348-7.39-7.34V7.47c0-3.993 3.241-7.341 7.39-7.341z",
  transform: "translate(63 91.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#748DAD",
  d: "M129.124 119.056h221.192c3.76 0 6.742 2.962 6.742 6.697v15.068c0 3.735-2.982 6.697-6.742 6.697H129.124c-3.76 0-6.742-2.962-6.742-6.697v-15.068c0-3.606 3.112-6.697 6.742-6.697z",
  opacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__o)",
  d: "M33.748.644H228.23c3.501 0 6.483 2.833 6.483 6.44v15.583c0 3.477-2.852 6.44-6.483 6.44H33.748c-3.501 0-6.483-2.834-6.483-6.44V7.083c0-3.477 2.852-6.44 6.483-6.44z",
  opacity: 0.8,
  transform: "translate(122.345 118.412)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(72.076 123.564)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.594,
  cy: 9.788,
  fill: "url(#shorten-development_svg__p)",
  rx: 9.594,
  ry: 9.53
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.594,
  cy: 9.788,
  fill: "#23C386",
  rx: 5.575,
  ry: 5.538
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(95.414 123.564)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.594,
  cy: 9.788,
  fill: "url(#shorten-development_svg__q)",
  rx: 9.594,
  ry: 9.53
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.594,
  cy: 9.788,
  fill: "#23C386",
  rx: 5.575,
  ry: 5.538
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__r)",
  d: "M49.61 77.563l10 19.859 13.896-2.726s1.04 16.224 7.533 19.858c6.493 3.635 9.87 0 15.844.65.39-2.856-4.545-4.933-4.545-4.933 2.078-.649 4.285-.908 6.493-.649.26-3.245-4.415-4.672-4.415-4.672 1.558-.65 3.116-1.039 4.805-1.039-.26-4.802-10.13-2.725-10.13-2.725s6.883-27.517-8.831-30.502c-13.766-2.726-30.65 6.879-30.65 6.879z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__s)",
  d: "M85.325 6.825c-.13-3.634-2.208-4.413-4.026-4.283-1.689-5.97-11.559.13-11.818 6.23-.26 6.1-.13 24.79-4.676 27.516-6.493 3.894-29.35 7.269-27.273 19.21 2.208 13.11 32.338-1.558 38.702-10.124 4.935-6.62 4.675-26.348 5.324-30.242.39-2.207 3.117-3.505 7.143-2.985.26-3.764-1.688-4.933-3.376-5.322z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__t)",
  d: "M65.714 97.032C62.727 83.404 49.61 75.616 49.61 75.616L31.43 86.39l9.35 14.018s-14.415 7.398-15.195 14.796c-.779 7.399 4.286 9.865 5.715 14.797 4.026-1.298 2.078-5.97 2.078-5.97 2.078 1.427 3.896 3.374 5.065 5.71 2.987-2.076 1.298-6.1 1.298-6.1 2.208.779 4.156 2.077 5.585 3.894 2.727-4.673-4.286-10.254-4.286-10.254s28.182-4.672 24.675-20.248z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__u)",
  d: "M59.87 54.979c-6.234-13.758-32.078-9.345-30.39-2.337 3.897 16.355-2.857 21.157-.26 33.228 2.468 11.292 9.481 14.018 12.988 16.614 8.311 6.23 21.428-6.75 25.195-17.393 3.376-10.124-4.156-22.714-7.533-30.112z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__v)",
  d: "M52.597 28.37c-5.584-8.436 7.533-6.489 5.585-19.468 3.896 2.725 6.493 6.879 7.532 11.551 1.04 5.841 4.286 9.216 3.117 14.148-1.169 4.543-6.493 4.802-9.09 3.375-4.286-2.596-4.936-6.36-7.144-9.605z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__w)",
  d: "M54.156 17.598c-7.273-5.062-24.675-2.985-32.727 12.98-2.598 5.191 7.532 1.687 3.636 12.72-5.714 16.224 30.909 19.468 38.961 15.185 1.039-.519 5.584-7.917 4.156-11.551.13-1.039.26-2.207.26-3.375 2.727-1.947-.13-5.581-1.17-6.62 1.43-3.764.91-6.36-.259-8.436-1.688-2.596-9.74-8.697-12.857-10.903z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M71.818 123.573c.78-.779 2.078-2.206 1.688-3.245h-.13c-.65 1.039-1.688 1.817-2.857 2.077v.13l1.299 1.038c-.13 0 0 0 0 0zm-2.208 1.687c.52-.26.91-.649 1.429-1.038v-.13l-1.429-1.168h-.13v2.207c0 .13.13.13.13.13zm-.909.13v-2.336a.28.28 0 00-.26-.26l-.52.13c-.389.13-.908.13-1.558.26h-.13a.28.28 0 00-.26.26s0 .129.13.129l2.468 1.817c0 .13.13.13.13 0zm-4.416 2.336c1.17-.389 2.338-.908 3.507-1.427.13-.13.26-.26.13-.39v-.13l-2.857-2.076h-.13l-1.04 3.634c0 .13 0 .26.39.39-.13 0-.13 0 0 0zm-1.298.13l1.169-3.894c0-.13-.13-.26-.26-.389h-.26l-1.558.13c-.91.13-1.689.13-2.728.26a.28.28 0 00-.26.259v.13l3.507 3.634c.13 0 .26 0 .39-.13zm-4.806 1.428c1.3-.26 2.338-.52 3.507-.779.13 0 .26-.26.26-.39v-.129l-2.987-3.115h-.13l-.91 4.153c-.13.13-.13.26.26.26zm-1.428-.13h.13l1.169-4.672a.28.28 0 00-.26-.26h-.13c-.52.13-1.039.13-1.688.26l-1.689.26c-.26 0-.39.259-.26.389v.13l2.728 3.893zm-4.675 1.039l3.506-.39c.26 0 .39-.26.26-.39v-.129l-2.338-3.504h-.13l-1.688 3.893c0 .13.13.39.39.52zm-1.17-.26l2.079-4.543c0-.13 0-.26-.13-.26h-.13c-.91.26-1.688.52-2.597.65l-1.559.389a.28.28 0 00-.26.26l2.468 3.374c-.13.13-.13.13.13.13-.13 0-.13 0 0 0zm-5.324.26c1.299.13 2.597.13 3.896.13.13 0 .39-.13.39-.26v-.13l-2.338-3.115h-.13c-.26.52-1.428 2.206-1.948 2.985 0 .13 0 .26.13.39 0-.13 0 0 0 0zm-2.078-2.596l.78 2.076h.13l1.688-2.596v-.26h-.52c-.52.13-1.039.26-1.558.26l-.52.13c.13 0 0 .13 0 .39zm-1.818 1.817c.52.13 1.039.39 1.688.519.13 0 .26 0 .13-.13l-.78-1.947h-.129l-.909 1.558c0-.13 0-.13 0 0 .13-.13.13-.13 0 0zm-1.429-.65l.65.26h.13l.909-1.427v-.13c-.78 0-1.429 0-2.078-.26-.52-.13-.91-.39-1.299-.778h-.13v.389c.26.908.91 1.557 1.818 1.947z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__x)",
  d: "M.91 19.675c.129-.26.389-.39.778-.39.26 0 .52 0 .65.13 5.324 2.726 11.168 4.024 17.143 3.894 1.558-.13 3.116 0 4.545.39 1.039.389 1.948 1.038 2.857 1.816C29.87 29.15 30.91 42.52 25.195 47.58c-2.208.65-4.676.65-6.883.13l1.039-3.764-3.767 2.596c-2.078-1.428-3.766-3.375-4.805-5.71l2.468-2.467H9.74c-.26-.649-.39-1.298-.52-1.817-1.428-5.84-5.454-10.384-6.752-12.59-.26-.52-1.3-2.336-1.559-2.726-.52-.39-.39-1.168 0-1.557z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__y)",
  d: "M24.935 34.212c-.909-1.558-2.078-4.024-7.662-5.192h-.13c-2.338-.39-4.546-.909-6.753-1.817-3.507-1.558-6.884-3.634-9.74-6.1.26.389 1.298 2.206 1.558 2.725 1.169 2.207 5.195 6.75 6.753 12.59.13.52.39 1.168.52 1.817h3.506l-2.468 2.466c1.04 2.337 2.728 4.284 4.806 5.711l3.766-2.596-1.04 3.764c2.339.65 4.676.65 7.014-.13 0-.518.13-.908.13-1.297.65-3.764 1.428-8.956-.26-11.941z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__z)",
  d: "M48.831 18.896c.52-.39 3.117-.13 3.117-.13.65.13 1.039.52.78.909-.78.649-1.689.908-2.728.649-1.299-.26-1.688-1.039-1.169-1.428z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__A)",
  d: "M48.701 21.622c1.429 0 .65 1.687-.13 1.947-.909.26-2.207-.26-2.077-.909.26-.649 1.558-1.038 2.207-1.038z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__B)",
  d: "M44.156 18.636c1.039 0 2.078.65 2.467 1.558.13.649-.649 1.038-2.337 1.298-1.689.26-3.507-.52-3.507-1.168 0-.65 2.338-1.558 3.377-1.688z",
  transform: "translate(0 79.367)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3A3F4C",
  d: "M52.598 117.343c.779-.13 1.558-.52 2.208-.909l-3.637-.909c-5.844-1.557-10-4.413-12.857-4.023-1.818.26-1.948 2.855-1.948 2.855.91-.39 1.948-.649 2.857-.779 2.078 0 4.156.52 6.104 1.298"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3EB883",
  d: "M45.195 114.876a19.2 19.2 0 00-5.454 0c0 .65.13 1.428.39 2.077.778 2.985 3.765 4.803 6.882 4.154 2.468-.13 4.546-1.688 5.585-3.894"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8FE6C1",
  d: "M47.273 116.434c-1.3-.39-2.728-.519-4.156-.26 0 .39.13.78.26 1.169.519 1.687 2.207 2.855 4.025 2.466 1.429-.13 2.728-1.039 3.247-2.336-1.039-.52-2.208-.909-3.376-1.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3A3F4C",
  d: "M63.507 113.578c.779-.908 1.818-1.427 2.987-1.817.52-.13 1.039 0 1.558.13 0 0-.39-1.817-1.428-1.817-1.559 0-3.247 2.726-5.974 4.673-1.04.649-2.078 1.298-2.338 1.298.52.13 1.169.13 1.818.13"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3EB883",
  d: "M60.13 116.304c.52 1.428 1.948 2.207 3.377 2.207 2.078-.13 2.857-2.077 2.987-4.024 0-.52 0-1.038-.13-1.558-.91 0-1.948.26-2.727.65"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8FE6C1",
  d: "M62.727 115.136a6.125 6.125 0 011.948-.779v.78c.13 1.037-.649 1.946-1.558 2.076-.78.13-1.559-.39-1.818-1.039.39-.389.909-.778 1.428-1.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M48.571 116.824s1.819 0 2.078.778c.26.78-2.857-.26-3.506-.39-.78-.129-.13-.518 1.428-.388zm14.156-1.558s-1.169.39-1.169 1.038c0 .65 1.689-.778 2.078-1.038.39-.26 0-.52-.909 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shorten-development_svg__C)",
  d: "M86.494 7.085c-.91-3.894-3.247-4.413-5.325-3.894-3.117-6.1-12.598 2.466-11.688 9.085.909 6.62 4.805 27.127.39 31.151-6.235 5.581-30.78 13.758-26.105 26.478 5.065 13.888 35.065-8.177 40.39-18.82 4.026-8.177.39-31.93.39-36.343 0-2.466 2.207-2.336 6.623-2.466-.39-4.283-2.727-5.191-4.675-5.191z",
  transform: "translate(0 79.367)"
}))));

function SvgShortenDevelopment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 548 313"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/shorten-development.101fea2b.svg";
export { SvgShortenDevelopment as ReactComponent };